import script from "./mixModals.vue?vue&type=script&lang=js"
export * from "./mixModals.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__